import { Component, ChangeDetectorRef, ViewChild } from '@angular/core';
import { ApiService } from '../../../../../shared/services/api.service';
import { API_ENDPOINTS } from '../../../../../shared/utils/const';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';


interface Option {
  label: string;
  value: string | number;
}
interface Question {
  answer?: any;
  dependentOn?: string | null;
  dependentValue?: string | null;
  headerText?: string | null;
  inputType: 'radio' | 'text' | 'dropdown' | 'slider' | 'multiselect' | 'label';
  isActive: boolean;
  max?: number | null;
  min?: number | null;
  options?: Option[] | null;
  optionsList?: Option[] | null;
  questionId: any;
  questionNumber: number;
  questionText: string;
  isRequired: boolean;
  minLength: number;
  maxLength: number;
  regexPattern: string;
}

interface Section {
  sectionTitle: string;
  questions: Question[];
}

interface FormValues {
  [key: string]: { [subKey: string]: string };
}

interface UserQuestions {
  UserId: any;
  UserType: number;
  msmeQuestionAnswerMapping: any[];
}


@Component({
  selector: 'app-msmeotherdetails',
  templateUrl: './msmeotherdetails.component.html',
  styleUrl: './msmeotherdetails.component.css'
})
export class MsmeotherdetailsComponent {
  form!: FormGroup;
  responseData: Section[] = [];
  currentSectionIndex = 0;
  msmeQuestionAnswerMapping: any[] = [];
  selectedObjects: any[] = [];
  selectedObjectsFromArray: any;
  otherInputControl!: FormControl;
  constructor(
    private fb: FormBuilder,
    private apiService: ApiService,
    private toastrService: ToastrService,
    private router: Router
  ) { }

  ngOnInit(): void {
    
    const obj = {
      MsMeId: sessionStorage.getItem("msmeid")
      , UserType: 4
    };
    this.createForm(obj);
    //this.form.disable();
    this.form.get('section')?.disable();
    this.form.get('radio_')?.disable();
  }

  createForm(obj: any) {
    this.form = this.fb.group({});
    this.apiService.getRequest(API_ENDPOINTS.MSME.GETOTHERDETAILSFORMSSIDC, obj).subscribe(
      (response: Section[]) => {
        this.responseData = response;

        this.defaultOtherValue = this.responseData[3]?.questions[6]?.answer || '';

        this.responseData.forEach((section) => {
          const sectionGroup = this.fb.group({});

          section.questions.forEach((question) => {
            if (question.isActive && question.questionId) {
              // Interpret the answer as Yes/No or retain the original answer
              const interpretedAnswer =
                question.answer?.toLowerCase() === 'yes'
                  ? 'Yes'
                  : question.answer?.toLowerCase() === 'no'
                    ? 'No'
                    : question.answer || '';

              let controlValue = interpretedAnswer;

              if (question.inputType === 'multiselect') {
                try {
                  // Parse the answer and extract labels
                  question.answer = JSON.parse(question.answer || '[]').map((item: any) => item.label);
                  controlValue = question.answer.join(', '); // Store as a readable string
                } catch {
                  question.answer = [];
                  controlValue = '';
                }
              }

              const control = new FormControl(
                controlValue,
                this.getValidators(question)
              );

              control.disable(); // Explicitly disable the control
              sectionGroup.addControl(`question_${question.questionId}`, control);

              if (question.dependentOn) {
                this.setDependency(sectionGroup, question);
              }
            }
          });

          this.form.addControl(section.sectionTitle, sectionGroup);
        });
      },
      (error) => {
        this.toastrService.error('Error fetching details', 'Oops...');
      }
    );
  }

  getSelectedLabel(question: any): string {
    const selectedValue = this.form.get('question_' + question.questionId)?.value;
    const selectedOption = question.optionsList.find((option: Option) => option.value === selectedValue);
    return selectedOption ? selectedOption.label : '';  // Return the label or empty string if no match
  }

  otherText: string = '';

  defaultOtherValue = 'Default Value';



  onInputChange(event: Event): void {
    this.defaultOtherValue = (event.target as HTMLInputElement).value;

  }

  isOtherSelected(): boolean {

    return this.selectedObjects.some(el => el.label === 'Other');
  }


  getValidators(question: Question) {
    const validators = [];
    if (question.isRequired) validators.push(Validators.required);
    if (question.minLength) validators.push(Validators.minLength(question.minLength));
    if (question.maxLength) validators.push(Validators.maxLength(question.maxLength));
    if (question.regexPattern) validators.push(Validators.pattern(question.regexPattern));
    return validators;
  }

  setDependency(sectionGroup: FormGroup, question: Question) {
    const parentControl = sectionGroup.get(`question_${question.dependentOn}`);
    const dependentControl = sectionGroup.get(`question_${question.questionId}`);

    // Disable initially, will be enabled based on value changes
    dependentControl?.disable();
    question.isActive = false;

    // Enable if the dependent field already has data
    if (question.answer !== null && question.answer !== '') {
      dependentControl?.enable();
      question.isActive = true;
    }

    // Subscribe to parent control's value changes
    parentControl?.valueChanges.subscribe((value) => {
      if (value === question.dependentValue) {
        dependentControl?.enable();
        question.isActive = true;
      } else {
        dependentControl?.disable();
        dependentControl?.reset();
        question.isActive = false;
      }
    });
  }


  nextSection() {
    const currentSection = this.form.get(this.responseData[this.currentSectionIndex].sectionTitle);
    if (currentSection?.valid) {
      this.currentSectionIndex++;
    } else {
      currentSection?.markAllAsTouched();
      this.toastrService.error('Please complete all required fields before proceeding.');
    }
  }

  previousSection() {
    this.currentSectionIndex--;
  }




  onSubmit() {
    const allValues: FormValues = this.form.getRawValue(); // Get all form values

    // Map through form values and convert all answers to strings
    this.msmeQuestionAnswerMapping = Object.entries(allValues).flatMap(
      ([sectionKey, section]) =>
        Object.entries(section)
          .map(([key, value]) => {
            if (key.startsWith('question_')) {
              const questionNumber = key.split('_')[1];


              const formattedValue = Array.isArray(value)
                ? JSON.stringify(value)
                : value?.toString() || '';


              return { questionId: Number(questionNumber), answer: formattedValue };
            }
            return null;
          })
          .filter((item) => item !== null) // Filter out any null values
    );



    this.msmeQuestionAnswerMapping = this.msmeQuestionAnswerMapping.map(item =>
      item.questionId === 28 ? { ...item, answer: this.defaultOtherValue } : item
    );

    const question27 = this.msmeQuestionAnswerMapping.find((item: any) => item.questionId === 27);
    const hasOther = Array.isArray(question27?.answer) && question27.answer.some((option: any) => option.label === 'Other');

    // If 'Other' is not found, set question_28's value to an empty string
    if (!hasOther) {
      this.msmeQuestionAnswerMapping = this.msmeQuestionAnswerMapping.map((item: any) =>
        item.questionId === 28 ? { ...item, answer: '' } : item
      );
    }



    // Prepare the result object for submission
    const resultList: UserQuestions = {
      UserId: sessionStorage.getItem("userId"),
      UserType: 4,
      msmeQuestionAnswerMapping: this.msmeQuestionAnswerMapping,
    };

    // Remove unnecessary properties if present
    if ('isNewEntry' in resultList) {
      delete resultList.isNewEntry;
    }


    // Send the data to the backend
    this.apiService.postRequest(API_ENDPOINTS.MSME.SAVEMSMEQUESTIONANSWE, resultList).subscribe(
      (response: any) => {
        if (response.status) {
          this.router.navigateByUrl('/msmeuserprofile');
          this.toastrService.success(response.message, 'Good job!');
        } else {
          this.toastrService.error('An unexpected error occurred', 'Oops...');
        }

      },
      (error: any) => {
        this.toastrService.error(error.error.message, 'Oops...');
      }
    );
  }

  getRadioValue(controlName: string): string {
    const control = this.form.get(controlName);
    if (control && control.value) {
      return control.value.toLowerCase() === 'yes' ? 'Yes' : 'No';
    }
    return 'No'; // Default to 'No' if no value is selected
  }

  hasError(sectionTitle: string, questionId: string, errorType: string) {
    const control = this.form.get(sectionTitle)?.get(`question_${questionId}`);
    return control?.hasError(errorType) && control.touched;
  }

  comparer(o1: any, o2: any): boolean {
    return o1 && o2 ? o1.label === o2.label : o2 === o2;
  }
}
